<script setup lang="ts">
// Root component — RouterView + global ModalRoot (inbox-104).
// Cabinet routes (meta.layout === 'cabinet') рендерятся внутри
// CabinetLayout — sidebar/topbar один на все cabinet-страницы.
// ModalRoot teleport'ает в body — рендерится поверх любого layout'a.
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import CabinetLayout from '@/layouts/CabinetLayout.vue';
import ModalRoot from '@/components/modals/ModalRoot.vue';

const route = useRoute();
const layout = computed(() => (route.meta?.layout as string) || 'minimal');
</script>

<template>
  <CabinetLayout v-if="layout === 'cabinet'">
    <RouterView />
  </CabinetLayout>
  <RouterView v-else />
  <ModalRoot />
</template>
